import { ClearStoreAction, LoadListDataAction, LoadListDataErrorAction, LoadListDataSuccessAction } from './actions.d';
import actionTypes from './actionTypes';
import { ILoadListDataRequestPayload, ILoadListDataSuccessPayload } from '../types';

const actions = {
  loadListData: <T1, T2>(payload: ILoadListDataRequestPayload<T1, T2>): LoadListDataAction<T1, T2> => ({
    type: actionTypes.LOAD_LIST_DATA,
    payload,
  }),
  loadListDataSuccess: (payload: ILoadListDataSuccessPayload): LoadListDataSuccessAction => ({
    type: actionTypes.LOAD_LIST_DATA_SUCCESS,
    payload,
  }),
  loadListDataError: (): LoadListDataErrorAction => ({
    type: actionTypes.LOAD_LIST_DATA_ERROR,
  }),
  clearStore: (): ClearStoreAction => ({
    type: actionTypes.CLEAR_STORE,
  }),
};

export default actions;
